import { render, staticRenderFns } from "./ActivityProductConfig.vue?vue&type=template&id=44b98231&scoped=true"
import script from "./ActivityProductConfig.vue?vue&type=script&lang=js"
export * from "./ActivityProductConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivityProductConfig.vue?vue&type=style&index=0&id=44b98231&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b98231",
  null
  
)

export default component.exports